<template>
    <div id="customer_view">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div class="right-asset-tab-list" v-if="displayMenu">
            <ul id="tabActive" class="activetabs">
                <li class="active"> <a href="javascript:void(0)" v-on:click="activetab = 1"> Customer Detail </a> </li>
                <li> <a href="javascript:void(0)" v-on:click="customerContactsTabClicked()"> Contacts </a> </li>
                <li v-if="canAddAddress"> <a href="javascript:void(0)" v-on:click="customerAddress()"> Address </a> </li>
                <li id="credit-detail"> <a href="javascript:void(0)" v-on:click="customerCreditInformation()"> Credit Details </a> </li>
                <li id="ach-detail"> <a href="javascript:void(0)" v-on:click="getCreditDetails('ach')">ACH Detail</a></li>
                <li id="ar-detail"> <a href="javascript:void(0)" v-on:click="accountRecievableInfo()"> AR Details </a> </li>
                <li v-if="canAddPriceBook"> <a href="javascript:void(0)" v-on:click="getPriceBooks()"> Price Book </a> </li>
                <li> <a href="javascript:void(0)" v-on:click="getCustomerComments()"> Comments </a> </li>
                <li id="crm-detail"> <a href="javascript:void(0)" v-on:click="customerCRM()"> CRM </a> </li>
                <li id="inv-detail"> <a href="javascript:void(0)" v-on:click="getCustomerInvoice()"> Invoices </a> </li>
                <li id="equip-detail"> <a href="javascript:void(0)" v-on:click="getCustomerReservation()"> Equipment </a> </li>
                <li> <a href="javascript:void(0)" v-on:click="assetsDeposits()"> Deposit Requirement </a> </li>
                <li> <a href="javascript:void(0)" v-on:click="customerActivityLogs()"> Activity Logs </a> </li>
                <li> <a href="javascript:void(0)" v-on:click="getCustomerDeposit()"> Exposure </a> </li>
                <li> <a href="javascript:void(0)" v-on:click="getCustomerPayment()"> Payment </a> </li>
                <li> <a href="javascript:void(0)" v-on:click="getCustomerAgreement()"> Agreements </a> </li>
                <li> <a href="javascript:void(0)" v-on:click="getContractAsset()"> Contract Asset </a> </li>
                <li v-if="parentId == customer_id"> <a href="javascript:void(0)" v-on:click="getCustomerAging()"> Aging Summary </a> </li>
                <li v-if="parentId == customer_id"> <a href="javascript:void(0)" v-on:click="getAgeTrailBalance()"> On-Line Aged Trial Balance </a> </li>
                <li id="credit-request"> <a href="javascript:void(0)" v-on:click="getCustomerCreditRequest()"> Customer Credit Request </a> </li>
                <!-- <li> <a href="javascript:void(0)" v-on:click="activetab = 11"> General Ledger </a> </li> -->
            </ul>
        </div>
        <div id="page-content-wrapper" class="admin-content-area left-asset-detail-section">
            <template v-if="cantAccessPage === true">
                <div class="page-name asset-view-page-name" v-if="name">
                    <div class="page-title">{{ name }} ({{ code }})</div>
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <div class="btn-groups pull-right">
                        <button type="submit" class="btn btn-secondary" v-on:click.prevent="downloadFlag = 1" >
                            Download Statement
                        </button>
                        <router-link
                          title="Edit Asset"
                          class="btn btn-primary"
                          v-if="activetab == 1 && canAddCustomer"
                                v-bind:to="{name: 'CustomerEdit',params:{id:$route.params.id}}">
                                <i class="fp-edit-icon"> </i> Edit
                        </router-link>

                        <button type="submit" class="btn btn-secondary pull-right ml-1" v-on:click.prevent="backButton" >
                             <i class="fp-back"> </i>    Back
                        </button>
                    </div>
                </div>
                <div class="container-fluid">
                    <!-- Download Customer Statement -->
                    <div class="admin-page-content customer-statement" v-show="downloadFlag == 1">
                        <section class="internal-container border-top-table-fl" >
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="CustomerStatementForm">
                                <div class="form-row row-cols-md-4 row-cols-1" >
                                    <div class="col form-group">
                                        <label class="control-label" for="as_of_date">As of Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="as_of_date" name="as_of_date" v-model="as_of_date" :config="optionsDate"></date-picker>
                                            <label for="as_of_date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="cycle">Statement Cycle:</label>
                                        <v-select v-model="statement_cycle" name="statement_cycle" placeholder="Select Statement Cycle."
                                            label="text" :options="cycleArr">
                                        </v-select>
                                    </div>
                                    <div class="col btn-group display-block" style="margin-top:25px;" v-if="customer_id == parentId">
                                        <button type="submit" v-on:click.prevent="child_statement = 0;customerStatementSend('download')" class="btn btn-primary pull-left">Download</button>
                                        <button type="button" class="btn btn-primary dropdown-toggle pull-left" data-toggle="dropdown">
                                        <span class="caret"></span>
                                        </button>
                                        <ul class="dropdown-menu p-0" role="menu">
                                            <li><button type="submit" class="dropdown-item" v-on:click.prevent="child_statement = 1;customerStatementSend('download')">With Sub Accounts </button></li>
                                        </ul>
                                    </div>
                                    <div class="col btn-groups text-left" v-else>
                                        <button type="submit" class="btn btn-secondary" style="margin-top:25px;" v-on:click.prevent="customerStatementSend('download')" >
                                            Download
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </section>
                    </div>
                    <p v-if="batchProcess && !batchComplete" class="alert-success p-2" id="processFetchBatchMsg">Downloading is in process. batch no. is {{batchNo}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = false, batchComplete=false"> Click Here</router-link> To view status</p>
                    <p v-if="batchComplete" class="alert-success p-2">Batch Processed Succesfully <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = false, batchComplete=false"> Click Here</router-link> to download!</p>
                    <p v-if="batchError" class="alert-danger p-2" id="processErrorBatchMsg">{{batchErrorMsg}}<button type="button" class="close close-alert" v-on:click="batchError = false;batchErrorMsg = ''">×</button></p>
                    <!-- Download Customer Statement -->
                    <!-- Customer Details -->
                    <div id="customer-detail" class="admin-page-content customer-view list-view" v-show="activetab == 1">
                        <!--Print Backend Error message-->
                        <section class="internal-container border-top-table-fl">

                            <div class="form-row section-divider">
                                <div class="col-md-6">
                                    <div class="row form-group">
                                        <label class="col">Account Number:</label>
                                        <span class="col"> {{ code }} </span>
                                    </div>
                                    <div class="row form-group" v-if="showfield">
                                        <label class="col">Class:</label>
                                        <span class="col"> {{ custClass }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Status:</label>
                                        <span class="col"> {{ status }} </span>
                                    </div>
                                    <div class="row form-group" v-if="!showfield">
                                        <label class="col">Bill Cus Id:</label>
                                        <span class="col">{{ billCust }} </span>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="row form-group">
                                        <label class="col">Name:</label>
                                        <span class="col"> {{ name }} </span>
                                    </div>
                                    <div class="row form-group" v-if="showfield">
                                        <label class="col">Size of Fleet:</label>
                                        <span class="col"> {{ sizeOfFleet }} </span>
                                    </div>
                                    <div class="row form-group" v-if="showfield">
                                        <label class="col">Customer Since:</label>
                                        <span class="col"> {{ customerSince }} </span>
                                    </div>
                                    <div class="row form-group" v-if="showfield">
                                        <label class="col">NationalLease:</label>
                                        <span class="col"> {{ is_national_lease }} </span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-row section-divider">
                                <div class="col-md-6">
                                    <div class="row form-group">
                                        <label class="col">Address:</label>
                                        <span class="col"> {{ address }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">City:</label>
                                        <span class="col"> {{ city }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">State:</label>
                                        <span class="col"> {{ state }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Zip/Postal Code:</label>
                                        <span class="col"> {{ postcode }} </span>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <!-- <div class="row form-group">
                                        <label class="col">Alternate Phone:</label>
                                        <span class="col"> {{ alternateNo }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Fax:</label>
                                        <span class="col"> {{ fax }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Credit Contact:</label>
                                        <span class="col"> {{ credit_contact }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Sales Contact:</label>
                                        <span class="col"> {{ sales_contact }} </span>
                                    </div>-->
                                    <div class="row form-group" v-if="showfield">
                                        <label class="col">Location:</label>
                                        <span class="col"> {{ location }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Phone:</label>
                                        <span class="col"> {{ phone }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Email:</label>
                                        <span class="col"> {{ email }} </span>
                                    </div>
                                    <div class="row form-group" v-if="showfield">
                                        <label class="col">Credit Manager:</label>
                                        <span class="col"> {{ cmName }} </span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-row section-divider">
                                <div class="col-md-6">
                                    <div class="row form-group" v-if="showfield">
                                        <label class="col">Type:</label>
                                        <span class="col"> {{ cust_type }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Sales Representative:</label>
                                        <span class="col"> {{ sales_representative }} </span>
                                    </div>
                                    <!-- <div class="row form-group">
                                        <label class="col">Pay Term:</label>
                                        <span class="col"> {{ pay_term }} </span>
                                    </div> -->
                                    <div class="row form-group">
                                        <label class="col">Deposit Check Required:</label>
                                        <span class="col"> {{ depositeCheck }} </span>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="row form-group">
                                        <label class="col">Stage:</label>
                                        <span class="col" v-if="stage == 'potential'"> Pending Approval </span>
                                        <span class="col" v-else> {{ titleCase(stage) }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Open Invoice:</label>
                                        <span class="col"> {{ open_invoice }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Open Date:</label>
                                        <span class="col"> {{ open_date }} </span>
                                    </div>
                                    <div class="row form-group" v-if="showfield">
                                        <label class="col">Added By:</label>
                                        <span class="col"> {{ addedBy }} </span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-row section-divider">
                                <div class="col-md-6">
                                    <!-- <div class="row form-group">
                                        <label class="col">Credit Limit:</label>
                                        <span class="col"> {{ creditLimit }} </span>
                                    </div> -->
                                    <!-- <div class="row form-group">
                                        <label class="col">Ignore WO Account Pending:</label>
                                        <span class="col"> {{ ignoreWoCreditCheck }} </span>
                                    </div> -->
                                    <!-- <div class="row form-group">
                                        <label class="col">Error At:</label>
                                        <span class="col"> {{ errorAt }} </span>
                                    </div> -->
                                    <div class="row form-group">
                                        <label class="col">PO Required:</label>
                                        <span class="col"> {{ poRequired }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Term:</label>
                                        <span class="col"> {{ term }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Fuel Term:</label>
                                        <span class="col"> {{ fuelTerm }} </span>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <!-- <div class="row form-group">
                                        <label class="col">Credit On Hand:</label>
                                        <span class="col"> {{ creditOnHand }} </span>
                                    </div> -->
                                    <div class="row form-group">
                                        <label class="col">WO Warning At:</label>
                                        <span class="col"> {{ woWarningAt }} </span>
                                    </div>
                                    <!-- <div class="row form-group">
                                        <label class="col">Maintenance Limit:</label>
                                        <span class="col"> {{ maintenanceLimit }} </span>
                                    </div> -->
                                    <div class="row form-group">
                                        <label class="col">Outstanding AR:</label>
                                        <span class="col"> {{ outstandingAr }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">On Account Balance:</label>
                                        <span class="col"> {{ on_balance_amount }} </span>
                                    </div>
                                    <!-- <div class="row form-group">
                                        <label class="col">Tax:</label>
                                        <span class="col"> {{ tax }} </span>
                                    </div> -->
                                    <!-- <div class="row form-group">
                                        <label class="col">Use Standard Billing Hours:</label>
                                        <span class="col"> {{ stadardBillingHours }} </span>
                                    </div> -->
                                </div>
                            </div>

                          <div class="form-row no-divider" v-if="showfield">
                            <div class="col-md-6">
                              <div class="row form-group">
                                <label class="col">Corcentric Enabled:</label>
                                <span class="col"> {{ cor_enabled }} </span>
                              </div>
                              <div class="row form-group">
                                <label class="col">Corcentric Code:</label>
                                <span class="col"> {{ cor_code }} </span>
                              </div>
                              <div class="row form-group">
                                <label class="col">Corcentric default po:</label>
                                <span class="col"> {{ cor_default_po }} </span>
                              </div>
                              <div class="row form-group">
                                <label class="col">Corcentric Invoice Start Date:</label>
                                <span class="col"> {{ cor_inv_date }} </span>
                              </div>
                              <div class="row form-group">
                                <label class="col">Corcentric Enabled Date:</label>
                                <span class="col"> {{ cor_enabled_date }} </span>
                              </div>
                            </div>
                          </div>

                            <!-- <div class="form-row no-divider">

                            </div> -->
                        </section>
                        <!-- <div class="data-table bg-white border-top-table-fl">
                          <section class="view-page-table bg-white data-table p-0 mt-4">
                            <div class="journal-title" >
                                <h5> Contact Details </h5>
                            </div>
                            <app-customer-contacts  :listFlag="'customerContact'" :moduleId="customer_id">
                            </app-customer-contacts>
                          </section>
                        </div> -->
                    </div>
                    <!-- Customer Details -->

                    <div id="customer-ach-details" class="admin-page-content customer-view list-view" v-show="activetab == 3">
                        <section class="internal-container border-top-table-fl">
                            <div class="form-row no-divider">
                                <div class="col-md-6">
                                    <div class="row form-group">
                                        <label class="col">Application For :</label>
                                        <template v-for="(app , key) in application_for">
                                            <span class="col"><a v-if="app && key != 0" :key="key">&nbsp;&nbsp;|</a>&nbsp;<span :key="key">{{titleCase(app)}}</span></span>
                                        </template>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Company Name :</label>
                                        <span class="col">{{titleCase(dataSet.company_name)}}</span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Phone Number :</label>
                                        <span class="col">{{titleCase(dataSet.phone)}}</span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Business Type :</label>
                                        <span class="col" >{{titleCase(dataSet.business_type)}}</span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">City :</label>
                                        <span class="col">{{dataSet.city}}</span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">State :</label>
                                        <span class="col">{{dataSet.state}}</span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Zip :</label>
                                        <span class="col" >{{titleCase(dataSet.zip)}}</span>
                                    </div>

                                    <div class="row form-group">
                                        <label class="col">Title :</label>
                                        <span class="col" >{{titleCase(dataSet.title)}}</span>
                                    </div>

                                    <div class="row form-group">
                                        <label class="col">EIN :</label>
                                        <span class="col" >{{dataSet.federal_tx_id}}</span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Current Business With :</label>
                                        <span class="col" >{{dataSet.which_company}}</span>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="row form-group">
                                        <label class="col">Signature :</label>
                                        <span class="col" v-if="dataSet.signature">
                                            <img :src="dataSet.signature" height="90" alt=""/>
                                        </span>
                                        <span class="col" v-else>
                                            NA
                                        </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Signature :</label>
                                        <span class="col" v-if="dataSet.signature1">
                                            <img :src="dataSet.signature1" height="90" alt=""/>
                                        </span>
                                        <span class="col" v-else>
                                            NA
                                        </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Resale Document :</label>
                                        <span class="col">
                                            <a href="javascript:void(0)" v-on:click="downloadDoc(dataSet.resale_doc_path , 'credit')">
                                                <img style="float:right;width:200px;height:auto;" :src="basePath + '/resaleDoc/' + dataSet.resale_doc_path" alt="NA"/>
                                            </a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>

                    <!--Customer ACH Details-->
                    <div id="customer-ach-details" class="admin-page-content customer-view list-view" v-show="activetab == 4">
                        <section class="internal-container border-top-table-fl" >
                            <template v-if="achFlag==true" >
                                <div class="btn-groups text-right mb-3 border-bottom pb-3">
                                    <span v-if="achExist==true">
                                        Your ACH Detail For this Customer is already Exist. Click on Update to save ACH detail
                                    </span>
                                    <a href="javascript:void(0)" class="btn btn-primary" v-on:click="getCustomerEmail('update')" v-if="achExist!=true && customer_id == parentId"> Request For Update Detail </a>
                                </div>
                                <div class="form-row no-divider">
                                    <div class="col-md-6">
                                        <div class="row form-group">
                                            <label class="col">Depository Name :</label>
                                            <span class="col">{{titleCase(dataSet.depository_name)}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Branch :</label>
                                            <span class="col" >{{titleCase(dataSet.branch)}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">City :</label>
                                            <span class="col">{{dataSet.city}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">State :</label>
                                            <span class="col">{{dataSet.state}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Zip :</label>
                                            <span class="col" >{{titleCase(dataSet.zip)}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Transit Number :</label>
                                            <span class="col">{{titleCase(dataSet.transit_number)}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Voided Check :</label>
                                            <!-- <span class="col">
                                                <template v-if="dataSet.doc_path!=''">
                                                    <template v-for="(doc , key) in dataSet.doc_path">
                                                        <a :key="key" href="javascript:void(0)" v-on:click="downloadDoc(doc.url , 'ach')">
                                                            <img :src="doc.url" alt="No Preview" class="mb-3"/>
                                                        </a>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <span>NA</span>
                                                </template>
                                            </span> -->
                                            <span class="col">
                                                <template v-if="dataSet.doc_path !=''" >
                                                    <template v-for="(doc , key) in dataSet.doc_path">
                                                            <a :key="'i' + key" v-if="key > 0">&nbsp;&nbsp; | &nbsp;&nbsp;</a>
                                                            <a :key="key" href="javascript:void(0)" v-on:click="downloadDoc(doc.url,'ach')">
                                                                <span class="color-blue">{{doc.display_name}}</span>
                                                            </a>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    NA
                                                </template>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="row form-group">
                                            <label class="col">Signature :</label>
                                            <span class="col" v-if="dataSet.signature && dataSet.signature != 'undefined'">
                                                <img :src="dataSet.signature" height="90" alt=""/>
                                            </span>
                                            <span class="col" v-else>
                                                NA
                                            </span>
                                        </div>

                                        <div class="row form-group">
                                            <label class="col">Signature :</label>
                                            <span class="col" v-if="dataSet.signature1 && dataSet.signature1 != 'undefined'">
                                                <img :src="dataSet.signature1" height="90" alt=""/>
                                            </span>
                                            <span class="col" v-else>
                                                NA
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="no-data">
                                    <div class="btn-groups text-right mb-3 border-bottom pb-3" v-if="customer_id == parentId">
                                        <a href="javascript:void(0)" class="btn btn-primary" v-on:click="getCustomerEmail('create')"> Request Detail </a>
                                    </div>
                                    No Data Found...
                                </div>
                              </template>
                        </section>
                        <div class="modal fade " id="customer-ach-email-modal" ref="approveRejectModal" data-backdrop="static" data-keyboard="false" aria-labelledby="approveRejectModal" aria-hidden="true">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Customer Emails</h5>
                                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                                    </div>
                                    <div class="modal-body">
                                        <table aria-describedby="table" class="table">
                                            <tr>
                                                <td colspan="2">Notification will be send to the below mentioned email</td>
                                            </tr>
                                            <tr v-for="(row,key) in emailRows">
                                                <td>
                                                    <input type="text" class="form-control" v-model="row.email" id="email" placeholder="Enter Email" name="email">
                                                    <span class="field-error" v-if="row.emailError!=''">{{row.emailError}}</span>
                                                </td>
                                                <td>
                                                    <a v-on:click="removeElement(row);" style="cursor: pointer" v-if="emailRows.length > 1">
                                                        <img src="/static/images/remove-icon-small.png"  alt="">
                                                    </a>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="2"><button type="button" class="btn btn-primary" @click="addRow" v-if="emailRows.length < 5 ">Add Email</button></td>
                                            </tr>
                                        </table>
                                        <br/>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-tertiary" data-dismiss="modal">Close</button>
                                        <button type="button" class="btn btn-primary" v-on:click="sendRequestForDetail()">Send Mail</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> <!--Customer ACH Details-->
                    <!--Customer Contacts-->
                    <div id="customer-contacts" class="admin-page-content customer-view list-view" v-show="activetab == 5">
                        <section class="internal-container border-top-table-fl">
                        <!-- <div class="bg-white data-table p-0"> -->
                            <app-customer-contacts v-if="enableCustContact" :listFlag="'customerContact'" :moduleId="customer_id">
                            </app-customer-contacts>
                        <!-- </div> -->
                        </section>
                    </div>
                    <!--Customer Contacts-->
                    <!--Customer Credit Details-->
                    <div id="customer-credit-details" class="admin-page-content customer-view list-view" v-show="activetab == 6">
                        <section class="internal-container border-top-table-fl">
                            <app-customer-credit v-if="customerCreditLoad" :moduleId="customer_id"></app-customer-credit>
                        </section>
                    </div>
                    <!--Customer Credit Details-->

                    <!--Customer AR Details-->
                    <div id="customer-ar-details" class="admin-page-content customer-view list-view" v-show="activetab == 7">
                        <section class="internal-container border-top-table-fl">
                            <app-account-receivable-info v-if="arInfoLoad"></app-account-receivable-info>
                        </section>
                    </div>
                    <!--Customer AR Details-->

                    <!--Price Book Details-->
                    <div id="customer-ar-details" class="admin-page-content customer-view list-view" v-show="activetab == 10">
                        <section class="internal-container border-top-table-fl">
                            <app-customer-price-book v-if="customerPriceBookLoad" :moduleId="customer_id"></app-customer-price-book>
                        </section>
                    </div>
                    <!--Customer AR Details-->

                    <!--Customer Comments-->
                    <div id="customer-comments" class="admin-page-content customer-view list-view" v-show="activetab == 12">
                        <section class="internal-container border-top-table-fl">
                            <app-customer-comment v-if="customerCommentLoad" :moduleId="customer_id"></app-customer-comment>
                        </section>
                    </div>
                    <!--Customer AR Details-->

                    <!--Customer Activity Logs-->
                    <div id="customer-activity-logs" class="admin-page-content" v-show="activetab == 8">
                        <section class="internal-container border-top-table-fl">
                            <div class="bg-white data-table p-0">
                                <customer-activity-log-list :activityLogVal="activityLogsTabValue"></customer-activity-log-list>
                            </div>
                        </section>
                    </div> <!--Customer Activity Logs-->

                    <!--Journals-->
                    <div id="customer-journals" class="admin-page-content" v-show="activetab == 11">
                        <section class="internal-container border-top-table-fl">
                            <template v-if="journalsArr == undefined || journalsArr.length == 0">
                                <div class="no-data">No GL Found</div>
                            </template>
                            <template v-else>
                                <div class="table-responsive-sm">
                                <table aria-describedby="table" cellpadding="0" cellspacing="0" id="contact_table" class="table table-sm table-bordered font-1 table-striped" v-if="journalsArr != undefined && journalsArr.length > 0">
                                    <thead class="table-primary">
                                        <tr>
                                            <th scope="col">Account</th>
                                            <th scope="col">Reference</th>
                                            <th scope="col" style="text-align: right;">Debit</th>
                                            <th scope="col" style="text-align: right;">Credit</th>
                                            <th scope="col" style="text-align: right;">Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="(journalItem , journalKey) in journalsArr">
                                            <tr :key="'journal'+journalKey">
                                                <template v-if="journalItem.account_description == 'Total'">
                                                    <td style="text-align: right;">{{journalItem.account_description}}</td>
                                                </template>
                                                <template v-else>
                                                    <td>{{journalItem.account_description}}</td>
                                                </template>
                                                <td>{{journalItem.reference}}</td>
                                                <td style="text-align: right;">{{journalItem.debit}}</td>
                                                <td style="text-align: right;">{{journalItem.credit}}</td>
                                                <td style="text-align: right;">{{journalItem.journal_amount}}</td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                                </div>
                            </template>
                        </section>
                    </div>

                    <!--Customer CRM List -->
                    <div id="customer-crm-list" class="admin-page-content customer-view list-view" v-show="activetab == 13">
                        <template v-if="crmAdd">
                            <crm-create :fromModule="customerObj"></crm-create>
                        </template>
                        <template v-else>
                            <button v-if="canAddCrm" type="submit" class="btn btn-primary pull-right" v-on:click.prevent="addCrm"><i class="fp-add"> </i>Add</button>
                            <section class="internal-container border-top-table-fl" style="margin-top:40px !important;">
                                <div class="bg-white data-table p-0">
                                    <customer-crm-list v-if="enableCustCrm" :moduleVal="'customer'" :moduleId="customer_id"></customer-crm-list>
                                </div>
                            </section>
                        </template>
                    </div> <!--Customer CRM List -->

                    <!--Customer Invoice List -->
                    <div id="customer-invoice-list" class="admin-page-content customer-view list-view" v-show="activetab == 14">
                        <section class="internal-container border-top-table-fl">
                            <div class="bg-white data-table p-0">
                                <app-customer-invoice v-if="customerInvoiceLoad" :moduleVal="'customer'" :listFlag="'customerInvoice'" :customerId="customer_id"></app-customer-invoice>
                            </div>
                        </section>
                    </div> <!--Customer Invoice List -->

                    <!--Customer Reservation List -->
                    <div id="customer-reservation-list" class="admin-page-content customer-view list-view" v-show="activetab == 15">
                        <section class="internal-container border-top-table-fl">
                            <div class="bg-white data-table p-0">
                                <customer-reservation-list v-if="customerResrevationLoad" :reservationVal="customerResVal" :listFlag="'customerReservation'" :customerId="customer_id"></customer-reservation-list>
                            </div>
                        </section>
                    </div> <!--Customer Reservation List -->

                    <!--Customer Address Details-->
                    <div id="customer-ar-details" class="admin-page-content customer-view list-view" v-show="activetab == 16">
                        <section class="internal-container border-top-table-fl">
                            <app-customer-address v-if="enableCustAddress" :moduleId="customer_id"></app-customer-address>
                        </section>
                    </div> <!--Customer Address Details-->

                    <div id="customer-deposit" class="admin-page-content customer-view list-view" v-show="activetab == 17">
<!--                        <section class="bg-white">-->
<!--                            <div class="invoice-view-table" id="customer-deposit-view">-->

<!--                            </div>-->
<!--                        </section>-->
                        <section class="bg-white">
                            <customer-exposure-component :dataForTables="dataForTables"></customer-exposure-component>
                        </section>
                    </div>
                    <div id="customer-deposit" class="admin-page-content customer-view list-view" v-show="activetab == 18">
                        <section class="bg-white">
                            <div class="invoice-view-table" id="customer-deposit-view">
                                <table aria-describedby="table" class="table table-sm table-striped">
                                    <thead>
                                        <tr class="table-primary">
                                            <th>&nbsp;</th>
                                            <th>Code</th>
                                            <th>Name</th>
                                            <th>Pool</th>
                                            <th>Deposit</th>
                                            <th>Enabled</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="(assetsType, index) in assetsTypes">
                                            <tr v-bind:key="index">
                                                <td><input type="checkbox" :id="'depositSelect'+index" class="depositSelect"
                                                name="deposit" @input="depositSelected($event,assetsType)"></td>
                                                <td>
                                                    {{ assetsType.code }}
                                                </td>
                                                <td>
                                                {{ assetsType.name }}
                                                </td>
                                                 <td>
                                                {{ assetsType.pool_code }}
                                                </td>
                                                <td>
                                                    {{ assetsType.deposit_required }}
                                                </td>
                                                <td>
                                                {{ titleCase(assetsType.enabled) }}
                                                </td>
                                                <td>
                                                    <button id="editVehicleAssetsBtn" v-on:click.prevent="isEditClick(index, assetsType)" class="fp-edit"></button>
                                                    <!-- <button id="enableVehicleAssetsBtn" v-if="assetsType.enabled == 'no'" v-on:click.prevent="enableDeposit(index, assetsType)" class="btn btn-primary">Enable</button> -->
                                                    <!--button v-if="isEdit[index]" id="saveVehicleAssetsBtn" v-on:click.prevent="isEditClick(index, false)" class="fp-save"></button--->
                                                </td>

                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                                <span class="field-error">{{ assetTypeDepositeError }}</span>
                            </div>
                            <div class="btn-groups text-right">
                                <button type="submit" class="btn btn-secondary" v-on:click.prevent="enableDeposit" >
                                    <i class="fp-submit"> </i>    Enable
                                </button>
                            </div>
                        </section>
                        <div class="modal fade invoice-modal update-reading-modal" id="receiptModal" ref="receiptModal" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Asset Deposit</h5>
                                    </div>
                                    <div class="modal-body">
                                        <form id="importFile" class="addinspectionForm basic-form-container">
                                            <div class="form-row">
                                                <div class="col-md-12 form-group mb-4">
                                                    <!--label class="control-label require w-100" for="name">File:</label-->
                                                    <input type="text" class="form-control" v-model="deposit"
                                            id="code" placeholder="Enter Deposit" name="code" @keypress="isNumberCheck($event)">
                                                </div>
                                                <strong id="errorMsg" class="field-error">{{errorMsg}}</strong>
                                            </div>
                                        </form>
                                    </div>
                                    <div class="modal-footer btm-action-btn-fl">
                                        <button class="btn btn-primary" id="myButton" v-on:click="saveDeposit()"> <i class="fp-save"> </i> Save</button>
                                        <button type="button" class="btn btn-tertiary" data-dismiss="modal"> <i class="fp-close"> </i> Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="customer-payment-details" class="admin-page-content customer-view list-view" v-show="activetab == 19">
                        <section class="internal-container border-top-table-fl">
                            <app-bank-transfer-list v-if="enableCustomerPayment" :customerId="customer_id"></app-bank-transfer-list>
                        </section>
                    </div> <!--Customer Address Details-->

                    <div id="customer-agreement-details" class="admin-page-content customer-view list-view" v-show="activetab == 21">
                        <section class="internal-container border-top-table-fl">
                            <app-rental-agreement-list v-if="enableCustomerAgreement" :customerId="parseInt(customer_id)"></app-rental-agreement-list>
                        </section>
                    </div> <!--Customer Agreement Details-->
                    <div id="customer-contract-details" class="admin-page-content customer-view list-view" v-show="activetab == 22">
                        <section class="internal-container border-top-table-fl">
                            <app-contract-asset-detail-list v-if="contractLoad" :customerId="parseInt(customer_id)"></app-contract-asset-detail-list>
                        </section>
                    </div> <!--Customer Agreement Details-->

                    <div id="customer-aging-details" class="admin-page-content customer-view list-view" v-show="activetab == 20">
                        <section class="bg-white">
                            <div class="table-responsive-sm" id="customer-aging-view" v-if="enableCustomerAging">
                                <table aria-describedby="table" class="table table-bordered table-sm font-1">
                                    <thead>
                                        <tr class="table-primary">
                                            <th>Customer</th>
                                            <th>Credit Limit</th>
                                            <th>Net AR Balance</th>
                                            <th>Pct Of Credit</th>
                                            <th>AR Balance</th>
                                            <th>On Account</th>
                                            <th>Available Credit</th>
                                            <th>1 - 30</th>
                                            <th>31 - 60</th>
                                            <th>61 - 90</th>
                                            <th>91+</th>
                                            <th>120+</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-if="agingSummaryArr && agingSummaryArr.length > 0">
                                            <template v-for="(ag, agindex) in agingSummaryArr">
                                                <tr v-bind:key="agindex">
                                                    <td>
                                                        {{ ag.customer_code }} | {{ag.customer_name}}
                                                    </td>
                                                    <td>
                                                    {{ ag.credit_limit }}
                                                    </td>
                                                    <td>
                                                        {{ ag.net_ar_balance }}
                                                    </td>
                                                    <td>
                                                        {{ ag.pct_of_credit }}
                                                    </td>
                                                    <td>
                                                        {{ ag.ar_balance }}
                                                    </td>
                                                    <td>
                                                        {{ ag.on_account }}
                                                    </td>
                                                    <td>
                                                        {{ ag.available_credit }}
                                                    </td>
                                                    <td>
                                                        {{ ag.period_1 }}
                                                    </td>
                                                    <td>
                                                        {{ ag.period_2 }}
                                                    </td>
                                                    <td>
                                                        {{ ag.period_3 }}
                                                    </td>

                                                    <td>
                                                        {{ ag.period_4 }}
                                                    </td>
                                                    <td>
                                                        {{ ag.period_5 }}
                                                    </td>
                                                </tr>
                                            </template>
                                        </template>
                                        <template v-else>
                                            No Data Found
                                        </template>
                                    </tbody>
                                </table>
                                <template v-if="agingSummaryArr && agingSummaryArr.length > 0">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label><b>AVG. Days to Pay :</b></label>
                                            <span>{{agingSummaryArr[0].average_days}}</span>
                                        </div>
                                    </div>
                                </template>

                                <span class="field-error">{{ assetTypeDepositeError }}</span>
                            </div>
                        </section>
                    </div>
                     <!--Customer Credit Request-->
                    <div id="customer-credit-request" class="admin-page-content customer-view list-view" v-show="activetab == 23">
                      <section class="interna-container border-top-table-fl">
                        <div class="bg-white data-table p-0">
                        <app-customer-credit-request v-if="enableCustomerCreditRequest" :from="'customer'" :customerId="parseInt(customer_id)"></app-customer-credit-request>
                        </div>
                      </section>
                    </div>
                    <div class="admin-page-content customer-view list-view" v-show="activetab == 24">
                      <div id="customer-detail" class="admin-page-content customer-view list-view">
                        <!--Print Backend Error message-->
                        <section class="internal-container border-top-table-fl">
                          <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="AddressForm">
                            <div class="row">
                              <div class="col-4 form-group">
                                <label class="control-label require" for="failure_date">Select Invoice as of Date:</label>
                                <div class="input-group">
                                  <date-picker placeholder="MM/DD/YYYY" id="invoice_till_date" name="invoice_till_date" v-model="invoice_till_date" :config="optionsDate"></date-picker>
                                  <label for="failure_date" class="fp-calendar input-calender-icon"></label>
                                </div>
                              </div>
                              <div class="col-4 form-group">
                                <label class="control-label" for="failure_date"></label>
                                <div class="input-group">
                                  <a href="javascript:void(0)" class="btn btn-primary" id="myButton" v-on:click="getAgeTrailBalance()"> <i class="fp-save"> </i> Set Date</a>
                                </div>
                              </div>
                            </div>
                          </form>
                          <div class="form-row section-divider">
                            <div class="col-md-6">
                              <div class="row form-group">
                                <label class="col">Customer:</label>
                                <span class="col"> {{customerInvoiceDetails.customer_code_and_name}} </span>
                              </div>
                              <div class="row form-group">
                                <label class="col">Credit Limit:</label>
                                <span class="col"> {{customerInvoiceDetails.customer_credit_limit}} </span>
                              </div>
                              <div class="row form-group">
                                <label class="col">Average Days to Pay:</label>
                                <span class="col"> {{customerInvoiceDetails.customer_average_days_to_pay}} </span>
                              </div>
                              <div class="row form-group">
                                <label class="col">Last Payment:</label>
                                <span class="col"> {{customerInvoiceDetails.customer_last_invoice_date}}|{{customerInvoiceDetails.customer_last_invoice_amount}} </span>
                              </div>
                            </div>
                          </div>
                        </section>
                      </div>
                      <section class="bg-white">
                        <div class="table-responsive-sm">
                          <table aria-describedby="table" class="table table-bordered table-sm font-1">
                            <thead>
                            <tr class="table-primary">
                                <th>Document Type</th>
                              <th>Document Number</th>
                              <th>Document Date</th>
                              <th>Due Date</th>
                              <th>Invoice Amount</th>
                              <th>Balance</th>
                              <th>Current</th>
                              <th>1-29 Days Past Due</th>
                              <th>30-59 Days Past Due</th>
                              <th>60-80 Days Past Due</th>
                              <th>90+ Days Past Due</th>
                            </tr>
                            </thead>
                            <tbody>
                            <template v-if="agingTrailArr && agingTrailArr.length > 0">
                              <template v-for="(ag, agindex) in agingTrailArr">
                                <tr v-bind:key="agindex">
                                    <td>{{ ag.type }}</td>
                                  <td>{{ ag.invoice_number }}</td>
                                  <td>{{ag.invoice_date}}</td>
                                  <td>{{ag.due_date}}</td>
                                  <td class='text-right'>{{ag.amount}}</td>
                                  <td class='text-right'>{{ag.balance}}</td>
                                  <td class='text-right'>{{ag.current}}</td>
                                  <td class='text-right'>{{ag.period_1}}</td>
                                  <td class='text-right'>{{ag.period_2}}</td>
                                  <td class='text-right'>{{ag.period_3}}</td>
                                  <td class='text-right'>{{ag.period_4}}</td>
                                </tr>
                              </template>
                            </template>
                            <template v-else>
                              No Data Found
                            </template>
<!--                            <template v-if="agingTrailTotalRecords">-->
                              <tr>
                                <td></td>
                                <td>TOTALS:</td>
                                <td></td>
                                <td></td>
                                <td class='text-right'>{{agingTrailTotalRecords.amount_sum}}</td>
                                <td class='text-right'>{{agingTrailTotalRecords.total_amount}}</td>
                                <td class='text-right'>{{agingTrailTotalRecords.total_current_amount}}</td>
                                <td class='text-right'>{{agingTrailTotalRecords.total_period_1_amount}}</td>
                                <td class='text-right'>{{agingTrailTotalRecords.total_period_2_amount}}</td>
                                <td class='text-right'>{{agingTrailTotalRecords.total_period_3_amount}}</td>
                                <td class='text-right'>{{agingTrailTotalRecords.total_period_4_amount}}</td>
                              </tr>
<!--                            </template>-->
                            </tbody>
                          </table>
                          <!--                            <template v-if="agingSummaryArr && agingSummaryArr.length > 0">-->
                          <!--                              <div class="col-md-12">-->
                          <!--                                <div class="form-group">-->
                          <!--                                  <label><b>AVG. Days to Pay :</b></label>-->
                          <!--                                  <span>{{agingSummaryArr[0].average_days}}</span>-->
                          <!--                                </div>-->
                          <!--                              </div>-->
                          <!--                            </template>-->

                          <span class="field-error">{{ assetTypeDepositeError }}</span>
                        </div>
                      </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>

        </div>


    </div>
</template>
<script>
    import Vue from "vue";

    import {commonMixins} from '../../mixins/commonMixins';
    import CrmCreate from "@/components/CrmCreate.vue";
    import CustomerExposureComponent from "./CustomerExposureComponent.vue";

    Vue.component("crm-create", CrmCreate);
    Vue.component("customer-exposure-component",CustomerExposureComponent);
    let msgServer;

    export default {
        name: "CustomerView",
        components: {

            CustomerReservationList: () => import('@/components/Reservation/ReservationList.vue'),
            CustomerCrmList: () => import('@/components/CrmList.vue'),
            CustomerActivityLogList: () => import('@/components/ActivityLogList.vue'),
            appCustomerCredit: () => import('@/components/CustomerCreditView.vue'),
            appCustomerComment: () => import('@/components/customer/CustomerComments.vue'),
            appCustomerPriceBook: () => import('@/components/customer/CustomerPriceBook.vue'),
            appCustomerContacts: () => import('@/components/CustomerContactList.vue'),
            appCustomerInvoice:() => import('@/components/invoice/InvoiceList.vue'),
            appCustomerAddress:() => import('@/components/customer/CustomerAddress.vue'),
            appBankTransferList:() => import('@/components/accounting/BankTransferList.vue'),
            appRentalAgreementList:() => import('@/components/RentalAgreementList.vue'),
            appContractAssetDetailList: () => import('@/components/ContractAssetDetailList'),
            appCustomerCreditRequest:() => import('@/components/CustomerCreditRequest'),

        },
        mixins:[commonMixins],
        data: () => ({
            editAsset: null,
            deposit: '',
            isEdit: false,
            loading:false,
            cantAccessPage: "",
            permissions: [],
            assetsTypes: [],
            activetab: 1,
            code:"",
            custClass:"",
            billCust:"",
            name:"",
            sizeOfFleet:"",
            address:"",
            postcode:"",
            phone:"",
            alternateNo:"",
            fax:"",
            credit_limit:"",
            email:"",
            open_invoice:"",
            open_date:"",
            //credit_contact:"",
            sales_contact:"",
            sales_representative:"",
            state:"",
            city:"",
            stage:"",
            //buying_group:"",
            pay_term:"",
            cust_type:"",
            status:"",
            //dot:"",
            customerSince:"",
            // creditLimit:"",
            //creditOnHand:"",
            //ignoreWoCreditCheck:"",
            woWarningAt:"",
            //errorAt:"",
            //maintenanceLimit:"",
            poRequired:"",
            outstandingAr:"",
            on_balance_amount:"",
            term:"",
            //tax:"",
            cmName:"",
            //taxState:"",
            //stadardBillingHours:"",
            creditFlag:false,
            achFlag:false,
            dataSet:[],
            application_for:[],
            basePath:"",
            tabMenuArray:[],
            customerResVal:["","getcustreservation"],
            //customerContactTabValue: "dontLoadList",
            enableCustContact:false,
            enableCustAddress:false,
            activityLogsTabValue: "dontLoadList",
            customerContractTabValue: "dontLoadList",
            displayMenu:false,
            achExist:false,
            achId:0,
            customer_id:0,
            journalsArr:[],
            canAddCustomer:false,
            customerPriceBookLoad:false,
            customerCommentLoad:false,
            customerCreditLoad:false,
            customerInvoiceLoad:false,
            customerResrevationLoad:false,
            arInfoLoad:false,
            enableCustCrm:false,
            enableAssetsDeposits:false,
            requestFor:"",
            emailRows: [],
            pageKey:"",
            canAddAddress:false,
            canAddPriceBook:false,
            canAddCrm:false,
            crmAdd:false,
            customerObj:{},
            loadDepositOnce:false,
            depositeCheck:"",
            location:"",
            fuelTerm:"",
            fromUrl:"",
            assetTypeDepositeError:"",
            enableCustomerPayment:false,
            parentId:'',
            enableCustomerAging:false,
            enableCustomerCreditRequest:false,
            agingSummaryArr:[],
            CreditRequestArr:[],
            addedBy:'',
            enableCustomerAgreement:false,
            contractLoad:false,
            pool_id:'',
            selectedDeposit:[],
            is_national_lease:'No',
            statement_cycle:'',
            cycleArr: [
                {
                    text: "Monthly",
                    value: "monthly"
                },
                {
                    text: "Weekly",
                    value: "weekly"
                },
            ],
            as_of_date:'',
            optionsDate: {
                format: 'MM/DD/YYYY',
                useCurrent: false,
            },
            selectedArray:[],
            batchId:'',
            batchNo:'',
            batchProcess:false,
            batchComplete:false,
            batchError:false,
            batchErrorMsg:"",
            downloadFlag:0,
            child_statement:0,
            dataForTables: {},
            agingTrailArr: [],
            agingTrailTotalRecords: [],
            customerInvoiceDetails: [],
            invoice_till_date: null,
            cor_enabled: "",
            cor_default_po:"",
            cor_inv_date: "",
            cor_enabled_date:"",
            cor_code: "",
            velocity_env:process.env.NODE_ENV,
            showfield: true,
        }),
        watch: {

            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                      if(self.velocity_env == 'velev' || self.velocity_env == 'velev_test'){
                        if (permissions[i].name == 'ev_add_dealer') {
                            self.canAddCustomer = true;
                        }
                        if (permissions[i].name == 'ev_view_dealer') {
                            self.cantAccessPage = true;
                            self.displayMenu = true;
                            setTimeout(function(){
                                $('.right-asset-tab-list').on('click', 'li', function() {
                                    $('.right-asset-tab-list li.active').removeClass('active');
                                    $(this).addClass('active');
                                });
                            },200);
                            setTimeout(function () {
                                var path = window.location.pathname;
                                var segments = path.split("/");
                                if (segments[3]) {
                                    self.loadCustomer();
                                }
                            }, 100);
                        }
                        if (permissions[i].name == 'ev_add_dealer_address') {
                            self.canAddAddress = true;
                        }
                        if (permissions[i].name == 'ev_list_dealer_price_book') {
                            self.canAddPriceBook = true;
                        }
                        if (permissions[i].name == 'add_crm') {
                            self.canAddCrm = true;
                        }
                      }
                      else{
                        if (permissions[i].name == 'add_customer') {
                            self.canAddCustomer = true;
                        }
                        if (permissions[i].name == 'view_customer') {
                            self.cantAccessPage = true;
                            self.displayMenu = true;
                            setTimeout(function(){
                                $('.right-asset-tab-list').on('click', 'li', function() {
                                    $('.right-asset-tab-list li.active').removeClass('active');
                                    $(this).addClass('active');
                                });
                            },200);
                            setTimeout(function () {
                                var path = window.location.pathname;
                                var segments = path.split("/");
                                if (segments[3]) {
                                    self.loadCustomer();
                                }
                            }, 100);
                        }
                        if (permissions[i].name == 'add_customer_address') {
                            self.canAddAddress = true;
                        }
                        if (permissions[i].name == 'list_customer_price_book') {
                            self.canAddPriceBook = true;
                        }
                        if (permissions[i].name == 'add_crm') {
                            self.canAddCrm = true;
                        }
                      }
                    }
                }
            },
        },
        created: function() {

        },
        beforeDestroy() {
            // Make sure to close the connection with the events server
            // when the component is destroyed, or we'll have ghost connections!
            if (typeof msgServer !== 'undefined') {
                msgServer.close();
            }
        },
        mounted: function() {

            var self = this;

            if(self.velocity_env == 'velev' || self.velocity_env == 'velev_test'){
                self.showfield = false;
            }

            if(self.$route.query.fromUrl != "" && self.$route.query.fromUrl != undefined){
              self.fromUrl = atob(self.$route.query.fromUrl);
            }
            var path =  process.env.ROOT_API;

            var imgPath = path.split('/');

            self.basePath = imgPath[0]+'//'+imgPath[2];

            self.getPermissions();
            if(self.$route.params.viewTab == 'creditDetail' || (self.$route.query.viewTab != undefined && self.$route.query.viewTab == 'creditDetail')){

                setTimeout(function(){

                    $("#tabActive li").removeClass("active");
                    $('#credit-detail').addClass("active");
                    $('#credit-detail').click();
                    self.customerCreditInformation();
                },2000);

            }
            if(self.$route.params.viewTab == 'creditRequest' || (self.$route.query.viewTab != undefined && self.$route.query.viewTab == 'creditRequest')){

                setTimeout(function(){

                    $("#tabActive li").removeClass("active");
                    $('#credit-request').addClass("active");
                    $('#credit-request').click();
                    self.getCustomerCreditRequest();
                },2000);

            }
            if(self.$route.params.viewTab == 'achDetail'){
                setTimeout(function(){
                    self.getCreditDetails('ach')
                    $("#tabActive li").removeClass("active");
                    $('#ach-detail').addClass("active");
                },2000);
            }
            self.allResVal = [self.type,"getallreservation"];

            var path = window.location.pathname;
            var segments = path.split("/");
            self.pageKey='_customer_view_'+segments[3];
            //set value in customer object for crm
            self.customerObj.module = "customer";
            self.customerObj.customer_id = segments[3];
            self.customerObj.flag = "add";
            self.customerObj.crm_id = "";
            self.customer_id = self.customerObj.customer_id;

            if (self.$route.query.from && self.$route.query.from == 'crm'){
                setTimeout(function(){
                    self.customerCRM();
                    $("#tabActive li").removeClass("active");
                    $('#crm-detail').addClass("active");
                },2000);
            }
            self.getAssetsTypes();
            if(self.$route.query.viewTab == 'invoice') {
              this.$router.replace({ query: {} });
              setTimeout(function () {
                  $("#tabActive li").removeClass("active");
                  $('#inv-detail').addClass("active");
                  $('#inv-detail').click();
                  self.getCustomerInvoice();
              }
                  , 2000);
            }
            if(self.$route.query.viewTab == 'equipment') {
              this.$router.replace({ query: {} });
              setTimeout(function () {
                  $("#tabActive li").removeClass("active");
                  $('#equip-detail').addClass("active");
                  $('#equip-detail').click();
                  self.getCustomerReservation();
              }
                  , 2000);
            }
            if(self.$route.query.viewTab == 'accounts') {
              this.$router.replace({ query: {} });
              setTimeout(function () {
                  $("#tabActive li").removeClass("active");
                  $('#ar-detail').addClass("active");
                  $('#ar-detail').click();
                  self.accountRecievableInfo();
              }
                  , 2000);
            }

            //Join ViewEdit Channel
            self.join_view_edit_channel(segments[1],segments[2],segments[3]);

        },
        metaInfo() {
            return {
                title: (this.code != "") ? this.code + " | Customer View | " +process.env.COPYRIGHT_NAME:"Customer View | " +process.env.COPYRIGHT_NAME
            }
        },
        methods: {
            isNumberCheck: function(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf('.') != -1)) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            saveDeposit() {
              var self = this;
                self.loading = true;
                var fields = {
                  assetTypeId: self.editAsset.type_id,
                  deposit: self.deposit,
                  customer_id: self.customer_id,
                  pool_id: self.editAsset.pool_id,
                };
                $.ajax({
                    url: process.env.ROOT_API + "/assettypes/cust_deposit/add",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            $('#receiptModal').modal('hide');
                            self.getAssetsTypes();
                        }
                    },
                    error: function (jqXHR, exception) {
                      console.log(jqXHR);
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'asset-tyep-list')
                    }
                });

            },
            isEditClick(index, assetsType) {
              var self = this;
              console.log("assetsType == ", assetsType);
              console.log("edit == ", index);
              self.editAsset = assetsType;
              self.deposit = assetsType.deposit_required;
              self.deposit = self.deposit.replace("$", "");
              self.deposit = self.deposit.replace(",", "");

              $('#receiptModal').modal('show');
            },
            assetsDeposits(){
                var self = this;
                self.activetab = 18;
                self.enableAssetsDeposits = true;
                if(!self.tabMenuArray.includes(self.activetab)){
                    self.tabMenuArray.push(self.activetab);
                }
            },
            downloadDoc: function(doc , flag){
                var self = this;
                if(doc == ''){
                    self.$swal('','No Document availble','info');
                    return;
                }
                if(flag == 'credit'){
                var docPath = self.basePath + '/resaleDoc/' +doc;
                }else{
                var docPath = doc;

                }
                var save = document.createElement('a');
                save.href = docPath;
                save.download = docPath;
                save.target = '_blank';
                document.body.appendChild(save);
                save.click();
                document.body.removeChild(save);
            },
            getAssetsTypes() {
                // assetsTypes = []
                var self = this;
                self.loading = true;
                var fields = {
                  customer_id: self.customer_id,
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/assettypes/deposit/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                          self.assetsTypes = [];
                            self.assetsTypes = data.content.row;

                             if (self.assetsTypes && self.assetsTypes.length){
                                for(var i=0;i<self.assetsTypes.length;i++){
                                    $("#depositSelect"+i).prop('checked',false);
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.assetTypeDepositeError = "Remote server cannot be reached";
                        } else if ( jqXHR.status == 403) {
                            self.assetTypeDepositeError = " Sorry!, You don't have permission to access this page.";
                        } else {
                            self.assetTypeDepositeError = jqxhr.responseJSON.message;
                        }
                    }
                });

            },
            getCreditDetails(flag){
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");
                self.loading = true;

                if(flag == 'credit'){
                    self.activetab = 3;
                }
                if(flag == 'ach'){
                    self.activetab = 4;
                }
                var id = segments[3];
                // if (self.parentId != undefined){
                //     id = self.parentId;
                // }

                $.ajax({
                    url: process.env.ROOT_API + "/customer_credit_details/" + id,
                    type: "GET",
                    headers: this.ajxHeaders,
                    data:{
                        flag:flag
                    },
                    dataType: "json",
                    success: function (data) {

                        self.loading = false;

                        if (data.status == "success") {
                            if (data.content != null) {
                                self.dataSet = data.content;
                                console.log(self.dataSet);
                                self.application_for = data.application_for;
                                self.achId = data.content.id;
                                if (flag == 'ach') {
                                    if (data.content.achFlag == 'exist') {
                                        self.achExist = true;
                                        self.achId = data.content.id;
                                    }
                                }
                                self.achFlag = true;
                                console.log(self.dataSet);
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'achmessage')
                    }
                });
            },
            loadCustomer() {

                var path = window.location.pathname;
                var segments = path.split("/");
                var self = this;
                self.customer_id=segments[3];
                self.loading = true;


                $.ajax({
                    url: process.env.ROOT_API + "/customer/" + segments[3],
                    type: "GET",
                    headers: this.ajxHeaders,
                    data:{
                        action_flag : 'view', // pass action for notify: view, edit
                        is_notify_flag : true // notify if user viewing or editing
                    },
                    dataType: "json",
                    success: function (data) {

                        self.loading = false;
                        console.log(data)

                        if (data.status == "success") {
                            console.log(data.content);
                            self.name = data.content.name;
                            self.code = data.content.code;
                            self.custClass = data.content.className;
                            self.parentId = data.content.parent_id;
                            self.billCust = data.content.pcust_code;
                            self.avgPayDays = data.content.average_days;
                            if(data.content.locCode != null && data.content.locCode != "" ){
                                self.location = data.content.locCode+" | "+data.content.locName;
                            } else{
                                if (!self.showfield){
                                    self.location = "NONE";
                                }else{
                                    self.location = "-";
                                }
                            }

                            if ( data.content.deposit_check_required == 1 ) {
                                self.depositeCheck = "Yes";
                            } else {
                                self.depositeCheck = "No";
                            }

                            var storeObject={visited_page: {
                                path : "customer |" +self.code,
                                data : window.location.pathname,
                            }};
                            self.getRecentlyPagesMethod(storeObject);

                            if (data.content.size_of_fleet == 0) {
                                self.sizeOfFleet = "";
                            } else{
                                self.sizeOfFleet = data.content.size_of_fleet;
                            }
                            if(!data.content.address_line_1) {
                                self.address = "";
                            } else {
                                self.address = data.content.address_line_1 +','+ data.content.address_line_2;
                            }
                            if(data.content.state_id == null){
                                self.state = "";
                            } else {
                                self.state = data.content.stateName;
                            }
                            if(data.content.city_id == null){
                                self.city = "";
                            } else{
                                self.city = data.content.cityName;
                            }
                            self.status = self.ucString(data.content.status)
                            //self.dot = self.ucString(data.content.dot)
                            self.postcode = data.content.postcode
                            self.phone = data.content.phone_no
                            self.alternateNo = data.content.alternateNo
                            self.fax = data.content.custFax
                            self.email = data.content.email
                            self.stage = data.content.stage
                            if(data.content.open_invoice == null){
                                self.open_invoice = "";
                            } else{
                                self.open_invoice = data.content.open_inv.toFixed(2);
                            }
                            self.open_date=data.content.open_date
                            //self.buying_group=data.content.buying_group

                            //self.credit_contact = data.content.credit_contact
                            self.sales_contact = data.content.custEmail
                            if(data.content.salesRepresentativeName == null){
                                self.sales_representative = "";
                            } else{
                                self.sales_representative = data.content.salesRepresentativeName;
                            }
                            if(data.content.type == null){
                                self.cust_type = "";
                            }else{
                                self.cust_type = self.ucString(data.content.type)
                            }

                            if(data.content.createdByLName != null && data.content.createdByLName != ''){
                                self.addedBy = data.content.createdByFName+ ' '+data.content.createdByLName;
                            }else{
                                self.addedBy = data.content.createdByFName;
                            }

                            // if (data.content.termName != null && data.content.termName != "") {
                            //     self.pay_term = self.ucString(data.content.termName);
                            // }

                            // if (data.content.termNo != null && data.content.termNo != "") {
                            //     if (self.pay_term != "") {
                            //         self.pay_term = self.pay_term + " | " + data.content.termNo;
                            //     }else{
                            //         self.pay_term = data.content.termNo;
                            //     }
                            // }

                            // if (data.content.termPeriod != null && data.content.termPeriod != "") {
                            //     self.pay_term = self.pay_term + " " + data.content.termPeriod;
                            // }

                            // self.creditLimit = data.content.credit_limit;

                            self.cmName = data.content.cmName;

                            self.customerSince = data.content.customer_since;
                            // if ( data.content.credit_on_hand == 1 ) {
                            //     self.creditOnHand = "Yes";
                            // } else {
                            //     self.creditOnHand = "No";
                            // }

                            // if ( data.content.ignore_wo_credit_check == 1 ) {
                            //     self.ignoreWoCreditCheck = "Yes";
                            // } else {
                            //     self.ignoreWoCreditCheck = "No";
                            // }

                            if (data.content.woWarningAt == 0) {
                                self.woWarningAt = "";
                            } else {
                                self.woWarningAt = data.content.wo_credit_warning_at;
                            }

                            // if (data.content.error_at == 0) {
                            //     self.errorAt = "";
                            // } else {
                            //     self.errorAt = data.content.error_at;
                            // }

                            // if (data.content.maintenance_limit == 0) {
                            //     self.maintenanceLimit = "";
                            // } else {
                            //     self.maintenanceLimit = data.content.maintenance_limit;
                            // }

                            if ( data.content.po_required == 1 ) {
                                self.poRequired = "Yes";
                            } else {
                                self.poRequired = "No";
                            }
                            if (data.content.cor_enabled == 1){
                              self.cor_enabled="Yes";
                            }else{
                              self.cor_enabled="NO";
                            }
                            self.cor_default_po=data.content.cor_default_po;
                            self.cor_inv_date=data.content.cor_inv_start_date;
                            self.cor_enabled_date=data.content.cor_enabled_date;
                            self.cor_code=data.content.corcentric_code;

                            self.on_balance_amount = data.content.on_balance_amount;
                            self.outstandingAr = data.content.outstanding_ar;

                            self.term = self.titleCase(data.content.termName);
                            self.fuelTerm = self.titleCase(data.content.fuelTermName);
                            // self.tax = self.titleCase(data.content.taxName);
                            // self.taxState = data.content.taxstName;
                            // if ( data.content.use_standard_billing_hours == 1 ) {
                            //     self.stadardBillingHours = "Yes";
                            // } else {
                            //     self.stadardBillingHours = "No";
                            // }

                            if(data.content.credit_flag && data.content.credit_flag == 'true'){
                                self.creditFlag = true;
                            }
                            if (data.content.journals != undefined) {
                                self.journalsArr = data.content.journals;
                            }else{
                                self.journalsArr = [];
                            }
                            if (data.content.is_national_lease == 1){
                                self.is_national_lease = 'Yes';
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'custViewmessage')
                    }
                });
            },
            contractTabClicked(){
                var self = this;
                self.activetab = 2;
                if(!self.tabMenuArray.includes(self.activetab)){
                    self.tabMenuArray.push(self.activetab);
                    // this.$root.$emit('customer_contracts_opted');
                    this.$root.$emit('customer_contracts');
                    self.customerContractTabValue = "loadList";     // flag value set to loadList so that filters in list work properly.
                }
            },
            customerCreditInformation(){
                var self = this;
                self.activetab = 6;
                self.customerCreditLoad = true;
                if(!self.tabMenuArray.includes(self.activetab)){
                    self.tabMenuArray.push(self.activetab);
                    // this.$root.$emit('customer_credit_opted');
                }
            },
            customerContactsTabClicked(){
                var self = this;
                self.activetab = 5;
                self.enableCustContact = true;

                if(!self.tabMenuArray.includes(self.activetab)){
                    self.tabMenuArray.push(self.activetab);
                    // this.$root.$emit('customer_contact_opted');
                    //this.$root.$emit('customer_contact');
                    //self.customerContactTabValue = "loadList";      // flag value set to loadList so that filters in list work properly.
                }
            },
            customerAddress(){
                var self = this;
                self.activetab = 16;
                self.enableCustAddress = true;

                if(!self.tabMenuArray.includes(self.activetab)){
                    self.tabMenuArray.push(self.activetab);
                    // this.$root.$emit('customer_contact_opted');
                    //this.$root.$emit('customer_contact');
                    //self.customerContactTabValue = "loadList";      // flag value set to loadList so that filters in list work properly.
                }
            },
            accountRecievableInfo(){
                var self = this;
                self.activetab = 7;
                self.arInfoLoad = true;
                if(!self.tabMenuArray.includes(self.activetab)){
                    self.tabMenuArray.push(self.activetab);
                    this.$root.$emit('customer_account_opted');
                }
            },
            customerActivityLogs(){
                var self = this;
                self.activetab = 8;
                  var path = window.location.pathname;
                  var segments = path.split("/");
                // PR - Call Activity Log List API Every Time...
                if(!self.tabMenuArray.includes(self.activetab)){
                    // self.tabMenuArray.push(self.activetab);
                    this.$root.$emit('activity_log_opted','customer',segments[3]);
                    self.activityLogsTabValue = "loadList";     // flag value set to loadList so that filters in list work properly.
                }
            },
            getPriceBooks(){
                var self = this;
                self.activetab = 10;
                self.customerPriceBookLoad = true;
                if(!self.tabMenuArray.includes(self.activetab)){
                    self.tabMenuArray.push(self.activetab);
                }
            },
            getCustomerInvoice(){
                var self = this;
                self.activetab = 14;
                self.customerInvoiceLoad = true;
                if(!self.tabMenuArray.includes(self.activetab)){
                    self.tabMenuArray.push(self.activetab);
                }
            },
            getCustomerReservation(){
                var self = this;
                self.activetab = 15;
                self.customerResrevationLoad = true;
                if(!self.tabMenuArray.includes(self.activetab)){
                    self.tabMenuArray.push(self.activetab);
                }
            },
            getCustomerComments(){
                var self = this;
                self.activetab = 12;
                self.customerCommentLoad = true;
                if(!self.tabMenuArray.includes(self.activetab)){
                    self.tabMenuArray.push(self.activetab);
                }
            },
            customerCRM(){
                var self = this;
                self.activetab = 13;
                self.enableCustCrm = true;
                if(!self.tabMenuArray.includes(self.activetab)){
                    self.tabMenuArray.push(self.activetab);
                }
            },

            addRow: function () {
                var self = this;
                if(self.emailRows.length < 5) {
                    var index = self.emailRows.length - 1;
                    if(self.emailRows[index].email != ""){
                        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        if(!re.test(self.emailRows[index].email)){
                            self.emailRows[index].emailError = "Email is Invalid.";

                        }else {
                            self.emailRows[index].emailError = "";
                            self.emailRows.push({email: "", emailError: ""});
                        }
                    }else{
                        self.emailRows[index].emailError = "Email is Required.";
                    }
                }
            },
            removeElement: function (row) {
                var self = this;
                if(self.emailRows.length > 1) {
                    var index = self.emailRows.indexOf(row);
                    self.emailRows.splice(index, 1);
                }
            },
            getCustomerEmail(requestFor){
                var self = this;
                self.emailRows=[];
                $("#customer-ach-email-modal").modal("show");
                self.requestFor=requestFor;
                $.ajax({
                    url: process.env.ROOT_API + "/customer/details",
                    type: "GET",
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    data: {id:self.customer_id},
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            self.emailRows.push({email: data.content.email,emailError:""});
                        }else{
                            self.emailRows.push({email: "",emailError:""});
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'get-emails');
                    }
                });
            },
            sendRequestForDetail(){
                var self = this;
                var self = this;
                var error=false;
                for(var i=0;i<self.emailRows.length;i++)
                {
                    if(self.emailRows[i].email=="")
                    {
                        self.emailRows[i].emailError = "Email is Required.";
                        error=true;
                    }else{
                        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        if(!re.test(self.emailRows[i].email)){
                            self.emailRows[i].emailError = "Email is Invalid.";
                            error=true;
                        }
                    }
                }
                if(error==false) {
                    self.loading = true;
                    $.ajax({
                        url: process.env.ROOT_API + "/creditachdetail/request",
                        type: "POST",
                        data: {
                            id: self.customer_id,
                            flag: 'ach-detail',
                            request_for: self.requestFor,
                            emails: self.emailRows,
                        },
                        // data: {name: self.name, code: self.code, is_default: self.checkboxValue, id: segments[3]},
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {

                            self.loading = false;

                            if (data.code == 201) {

                            }
                            if (data.status == "success") {
                                $("#customer-ach-email-modal").modal("hide");
                                self.$swal('', 'Email has been sent to the customer', 'success');
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR, true, 'ach-detail-request');
                        }
                    });
                }

            },
            addCrm:function(){
                var self = this;

                self.crmAdd = true;
                self.customerObj.crm_id = "";
                self.customerObj.flag = "add";
            },
            cancelCrmFromView() {
                var self = this;
                self.crmAdd = false;
            },
            editCrmFromView(crmId){
                var self = this;
                self.crmAdd = true;
                self.customerObj.crm_id = crmId;
                self.customerObj.flag = "update";
            },
            getCustomerDeposit:function(){
                var self = this;

                self.activetab = 17;
                if (self.loadDepositOnce == false){

                    self.loading = true;
                    $.ajax({
                        url: process.env.ROOT_API + "/fetch-customer-deposit-detail",
                        type: "GET",
                        data: {
                            customer_id: self.customer_id,
                            type: 'html',
                        },
                        // data: {name: self.name, code: self.code, is_default: self.checkboxValue, id: segments[3]},
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            self.loadDepositOnce = true;
                            self.loading = false;

                            // if (data.view) {
                            // setTimeout(function(){
                            //         $("#customer-deposit-view").html("");
                            //         $("#customer-deposit-view").html(data.view);
                            //     },200);
                            // }
                          self.dataForTables = data.content;
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR, true, 'customer-deposit');
                        }
                    });
                }

            },


            getCustomerPayment(){
                var self = this;
                self.activetab = 19;
                self.enableCustomerPayment = true;
                if(!self.tabMenuArray.includes(self.activetab)){
                    self.tabMenuArray.push(self.activetab);
                }
            },

            getCustomerAgreement(){
                var self = this;
                self.activetab = 21;
                self.enableCustomerAgreement = true;
                if(!self.tabMenuArray.includes(self.activetab)){
                    self.tabMenuArray.push(self.activetab);
                }
                localStorage.setItem("agreement_list_prev_tab","all");
            },
            getContractAsset(){
                var self = this;
                self.activetab = 22;
                self.contractLoad = true;
                if(!self.tabMenuArray.includes(self.activetab)){
                    self.tabMenuArray.push(self.activetab);
                    // this.$root.$emit('work_order');
                    // self.workOrderVal = "loadList";   // flag value set to loadList so that filters in list work properly.
                }
            },

            getCustomerCreditRequest(){
              //console.log("checke the flow");
              var self = this;
              self.activetab = 23;
              self.enableCustomerCreditRequest = true;
              if(!self.tabMenuArray.includes(self.activetab)){
                    self.tabMenuArray.push(self.activetab);
              }
            },
            getCustomerAging(){
                var self = this;
                self.activetab = 20;
                if (self.enableCustomerAging == false){

                    self.loading = true;
                    $.ajax({
                        url: process.env.ROOT_API + "/fetch-customer-aging-detail",
                        type: "POST",
                        data: {
                            customer_id: self.customer_id,
                        },
                        // data: {name: self.name, code: self.code, is_default: self.checkboxValue, id: segments[3]},
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            self.enableCustomerAging = true;
                            self.loading = false;
                            self.agingSummaryArr = data.content.row;
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR, true, 'customer-aging');
                        }
                    });
                }
            },
          getAgeTrailBalance(){
            var self = this;
            self.activetab = 24;
              self.loading = true;
              $.ajax({
                url: process.env.ROOT_API + "/fetch-customer-single-invoice-aging-detail",
                type: "POST",
                data: {
                  customer_id: self.customer_id,
                  date: self.invoice_till_date,
                },
                // data: {name: self.name, code: self.code, is_default: self.checkboxValue, id: segments[3]},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                  console.log('Request Success',data.content);
                  self.loading = false;
                  self.agingTrailArr = data.content.row;
                  self.agingTrailTotalRecords = data.total_records;
                  self.customerInvoiceDetails = data.customer_details;
                },
                error: function (jqXHR, exception) {
                  self.loading = false;
                  self.generateStatusCodeMessage(jqXHR, true, 'customer-aging');
                }
              });
          },
         backButton() {
            var self = this;
            var url = "/dealer/list";
            if ( self.fromUrl != "" && self.fromUrl != undefined ) {
                url = self.fromUrl;
            }
            self.redirectPageUrl(url);

        },
            depositSelected:function(evt,depObj){
                var self = this;

                if (evt.target.checked == true){
                    self.selectedDeposit.push(depObj);
                }else{
                    const filteredItems = self.selectedDeposit.filter(function(item) {
                        return item.id !== depObj.id
                    })
                    self.selectedDeposit = filteredItems;
                }
                console.log(self.selectedDeposit);
            },
            enableDeposit:function(){
                var self = this;

                // console.log(typeObj.id);
                // var deposit_id = typeObj.id;

                if (!self.selectedDeposit.length){
                    self.$swal('','Please select deposit','info');
                    return;
                }

                self.loading = true;
                    $.ajax({
                        url: process.env.ROOT_API + "/enable-deposit",
                        type: "POST",
                        data: {
                            arr: JSON.stringify(self.selectedDeposit),
                            customer_id:self.customer_id
                        },
                        // data: {name: self.name, code: self.code, is_default: self.checkboxValue, id: segments[3]},
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            self.loading = false;
                            self.getAssetsTypes();
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR, true, 'customer-aging');
                        }
                    });

            },
            // download customer statement
            customerStatementSend(flag) {
                var self = this;
                self.loading = true;
                console.log(self.customer_id);
                console.log(JSON.stringify(self.customer_id));

                var fields = $("#CustomerStatementForm").serializeArray();
                if (self.statement_cycle != null && self.statement_cycle.value){
                    fields.push({name: "statement_cycle", value:self.statement_cycle.value});

                }else{
                    fields.push({name: "statement_cycle", value:''});

                }
                self.selectedArray.push(self.customer_id);
                fields.push({name: "seleted_all", value:'false'});
                fields.push({name: "customer", value:JSON.stringify(self.selectedArray)});
                fields.push({name: "email", value:self.email});
                fields.push({name: "as_of_date", value:self.as_of_date});
                fields.push({name: "flag", value:flag});
                fields.push({name: "child_statement", value:self.child_statement});

                $.ajax({
                    url: process.env.ROOT_API + "/customer-statement/send",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        self.enableEmail = false;
                        self.as_of_date = '';
                        self.statement_cycle = '';
                        self.showList = false;
                        self.selectedArray = [];
                        self.downloadFlag = 0;
                        // self.$refs.filterCustStatement.clearSelectAll();
                        if(data.content.id){
                            self.batchId = data.content.id;
                            self.batchNo = data.content.batch;
                            self.batchProcess = true;
                            self.checkBatchStatus();
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'customer-statement')
                    }
                });
            },
            // check batch status
            checkBatchStatus:function(){
                var self =  this;
                var otherParams = [];
                this.$sse(process.env.ROOT_API + '/check/batch-status/'+self.batchId, { format: 'json' }) // or { format: 'plain' }
                .then(sse => {
                    // Store SSE object at a higher scope
                    msgServer = sse;

                    // Listen for messages without a specified event
                    sse.subscribe('', data => {
                        if ( data.status == "1") {
                            self.batchProcess = false;
                            self.batchComplete = true;
                            sse.close();

                        }else if (data.status == "2") {
                            self.batchProcess = false;
                            otherParams = JSON.parse(data.other_params);
                            if(otherParams.noOpenInvoices != ''){
                              self.batchError = true;
                              self.batchErrorMsg = otherParams.noOpenInvoices;
                            }else{
                              self.batchError = true;
                              self.batchErrorMsg = data.message;
                            }
                            sse.close();
                        }
                    });

                })
                .catch(err => {
                    // When this error is caught, it means the initial connection to the
                    // events server failed.  No automatic attempts to reconnect will be made.
                    console.error('Failed to connect to server', err);
                });

            },
        }
    };

</script>



// WEBPACK FOOTER //
// src/components/customer/CustomerView.vue